import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class SocialMediaManagement extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Social Media Management"
					title={"social media management"}
					image={require('./image-7.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Social Media Management
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>It’s no secret - planning your social media content is time consuming!</p>
<p> That being said, social media is not something you should be ignoring. Social Media Management (or Programming), should be high on your to-do list for this year. </p>

<p>Your social platforms are generally the first thing your audience will go to for their preliminary research into your brand. Our aim is to create a clear direction and intent for your social posts, and create engaging, authentic content for your audience to comment on, interact with and share (all promoting your social community). With our Moshi gurus working alongside you to create a voice for your brand, authenticity will come naturally. 
</p>
<p>Our social media wizards have over 10 years combined experience in the world of Social Media Management, from creating 12 month strategies for Facebook, LinkedIn and Instagram to sharing our tips and techniques for Instagram Stories and Facebook Live.</p>								

<h4>Our Social Media strategies include: </h4>
								
        <ul class="with-icons">
              <li>A full 12 month plan of your social media posts (options for 3 months)</li>
<li>Quarterly themed content</li>
<li>Suggested <a href="https://www.moshi.com.au/whatwedo/public-relations">events</a> to be run throughout the year </li>
<li>Fully written captions (including hashtags)</li>
<li>Facebook Pixel management</li>
<li><a href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and videography</a> services as required</li>
<li>Control over replying to comments</li> 
<li>Reinvigorating your Facebook, LinkedIn or Instagram bios to attract the right followers
</li>
             
</ul>

<p>Let us take care of your social platforms so you can get back to the nuts and bolts of your business. 
</p> <p>
</p>
<img src={require('./social-manage.png')} style={{padding: 30}} height="375" width="350" alt="Inspired Interiors Instagram Content" className="align-centre" align="centre" />
<a href="https://www.moshi.com.au/what-weve-done/enable-wa"><img src={require('./social-photography.png')} style={{padding:30}}  height="375" width="350" alt="Enable WA Fair Images" className="align-centre" align="centre" /></a>
<img src={require('./social-plan.png')} style={{padding: 30}} height="375" width="350" alt="12 Month Management Plan" className="align-centre" align="centre" />


<br></br>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-marketing">Social Media Marketing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>		
	

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>
<h4>If you’re finding you just don’t have time to maintain an active social presence, it’s time to get Moshi Moshi involved.</h4> 
<h3>Give us a call to see how we can get the ball rolling! </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default SocialMediaManagement;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/SocialMediaManagement.js